// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submenu a {
  color: #737373;
}

.sticky .menu a {
  color: #fff;
}

.linkstop a {
  color: rgba(255, 255, 255, 0.7490196078);
}

.header.sticky .submenu a {
  color: rgba(255, 255, 255, 0.7490196078);
}

.logo .title {
  width: max-content;
}

.cancel {
  text-align: left;
}

.header .min-header .linkstop a {
  margin-right: 0;
  border-right: 0;
  padding-right: 0;
}

.content p {
  border-right: none !important;
}

.dropdown-menu {
  width: max-content;
  padding: 20px;
  height: 270px;
}

i svg {
  width: 24px;
  height: 24px;
}

.switch {
  margin: 0 10px;
  position: relative;
  display: inline-block;
  min-width: 56px;
  max-width: 56px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 4px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

input:checked + .slider:before {
  background-color: #0c836d;
}

.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
  width: 50px;
  background-color: #eee;
}

.blueRadio .container .checkmark {
  background-color: #1f2847;
}

.greenRadio .container .checkmark {
  background-color: #0c836d;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 20px;
  top: 6px;
  width: 10px;
  height: 20px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.searchpop .container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.weatherIcon {
  font-size: 14px !important;
}

.textCenter {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/layoutComponent/header/header.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;AAAR;;AAMQ;EACI,WAAA;AAHZ;;AASI;EACI,wCAAA;AANR;;AAUA;EACI,wCAAA;AAPJ;;AAWI;EACI,kBAAA;AARR;;AAYA;EACI,gBAAA;AATJ;;AAYA;EAII,eAAA;EACA,eAAA;EACA,gBAAA;AAZJ;;AAgBI;EACI,6BAAA;AAbR;;AAiBA;EACI,kBAAA;EACA,aAAA;EACA,aAAA;AAdJ;;AAkBI;EACI,WAAA;EACA,YAAA;AAfR;;AAmBA;EACI,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAhBJ;;AAmBA;EACI,UAAA;EACA,QAAA;EACA,SAAA;AAhBJ;;AAmBA;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;AAhBJ;;AAmBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;AAhBJ;;AA2BA;EAGI,2BAAA;AAxBJ;;AA4BA,oBAAA;AAEA;EACI,mBAAA;AA1BJ;;AA6BA;EACI,kBAAA;AA1BJ;;AA6BA;EACI,yBAAA;AA1BJ;;AA6BA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;AA1BJ;;AA8BA,wCAAA;AAGA,6BAAA;AAEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AA9BJ;;AAkCI;EACI,yBAAA;AA/BR;;AAoCI;EACI,yBAAA;AAjCR;;AAsCA,6DAAA;AAEA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AApCJ;;AAwCA,oCAAA;AAEA;EACI,cAAA;AAtCJ;;AA0CA,kCAAA;AAEA;EACI,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AAxCJ;;AA4CI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAzCR;;AA6CA;EACI,0BAAA;AA1CJ;;AA+CA;EACI,6BAAA;AA5CJ","sourcesContent":[".submenu {\r\n    a {\r\n        color: #737373;\r\n    }\r\n}\r\n\r\n.sticky {\r\n    .menu {\r\n        a {\r\n            color: #fff;\r\n        }\r\n    }\r\n}\r\n\r\n.linkstop {\r\n    a {\r\n        color: #ffffffbf;\r\n    }\r\n}\r\n\r\n.header.sticky .submenu a {\r\n    color: #ffffffbf;\r\n}\r\n\r\n.logo {\r\n    .title {\r\n        width: max-content;\r\n    }\r\n}\r\n\r\n.cancel {\r\n    text-align: left;\r\n}\r\n\r\n.header .min-header .linkstop a {\r\n    // border-right: none!important;\r\n    // margin-right: 0!important;\r\n    // padding-right: 0!important;\r\n    margin-right: 0;\r\n    border-right: 0;\r\n    padding-right: 0;\r\n}\r\n\r\n.content {\r\n    p {\r\n        border-right: none!important;\r\n    }\r\n}\r\n\r\n.dropdown-menu {\r\n    width: max-content;\r\n    padding: 20px;\r\n    height: 270px;\r\n}\r\n\r\ni {\r\n    svg {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n}\r\n\r\n.switch {\r\n    margin: 0 10px;\r\n    position: relative;\r\n    display: inline-block;\r\n    min-width: 56px;\r\n    max-width: 56px;\r\n    height: 28px;\r\n}\r\n\r\n.switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #ccc;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\n.slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 24px;\r\n    width: 24px;\r\n    left: 4px;\r\n    bottom: 2px;\r\n    background-color: white;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\ninput:checked+.slider {\r\n    // background-color: #2196F3;\r\n}\r\n\r\ninput:focus+.slider {\r\n    // box-shadow: 0 0 1px #2196F3;\r\n}\r\n\r\ninput:checked+.slider:before {\r\n    -webkit-transform: translateX(26px);\r\n    -ms-transform: translateX(26px);\r\n    transform: translateX(26px);\r\n}\r\n\r\n\r\n/* Rounded sliders */\r\n\r\n.slider.round {\r\n    border-radius: 34px;\r\n}\r\n\r\n.slider.round:before {\r\n    border-radius: 50%;\r\n}\r\n\r\ninput:checked+.slider:before {\r\n    background-color: #0c836d;\r\n}\r\n\r\n.container {\r\n    display: block;\r\n    position: relative;\r\n    padding-left: 35px;\r\n    margin-bottom: 12px;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n\r\n/* Hide the browser's default checkbox */\r\n\r\n\r\n/* Create a custom checkbox */\r\n\r\n.checkmark {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 40px;\r\n    width: 50px;\r\n    background-color: #eee;\r\n}\r\n\r\n.blueRadio {\r\n    .container .checkmark {\r\n        background-color: #1f2847;\r\n    }\r\n}\r\n\r\n.greenRadio {\r\n    .container .checkmark {\r\n        background-color: #0c836d;\r\n    }\r\n}\r\n\r\n\r\n/* Create the checkmark/indicator (hidden when not checked) */\r\n\r\n.checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n}\r\n\r\n\r\n/* Show the checkmark when checked */\r\n\r\n.container input:checked~.checkmark:after {\r\n    display: block;\r\n}\r\n\r\n\r\n/* Style the checkmark/indicator */\r\n\r\n.container .checkmark:after {\r\n    left: 20px;\r\n    top: 6px;\r\n    width: 10px;\r\n    height: 20px;\r\n    border: solid white;\r\n    border-width: 0 3px 3px 0;\r\n    -webkit-transform: rotate(45deg);\r\n    -ms-transform: rotate(45deg);\r\n    transform: rotate(45deg);\r\n}\r\n\r\n.searchpop {\r\n    .container {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n.weatherIcon {\r\n    font-size: 14px !important;\r\n}\r\n\r\n\r\n\r\n.textCenter{\r\n    text-align: center!important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
